import React from 'react';
import { FileController } from './definitions';

export const FileContext = React.createContext<FileController>({} as FileController);
export default FileContext;
